import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';

import { OperationConfirmationApproveModalComponent } from './operation-confirmation-approve-modal/operation-confirmation-approve-modal.component';
import { OperationConfirmationDetailsDrawerComponent } from './operation-confirmation-details-drawer/operation-confirmation-details-drawer.component';
import { OperationConfirmationComponent } from './operation-confirmation.component';
import { OperationConfirmationFilterComponent } from './operation-confirmation-filter/operation-confirmation-filter.component';
import { OperationConfirmationRejectModalComponent } from './operation-confirmation-reject-modal/operation-confirmation-reject-modal.component';
import { OperationConfirmationTableComponent } from './operation-confirmation-table/operation-confirmation-table.component';

@NgModule({
  declarations: [
    OperationConfirmationComponent,
    OperationConfirmationFilterComponent,
    OperationConfirmationTableComponent,
    OperationConfirmationApproveModalComponent,
    OperationConfirmationRejectModalComponent,
    OperationConfirmationDetailsDrawerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    B3DesignSystemWebModule,
  ],
  exports: [
    OperationConfirmationComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OperationConfirmationModule {}
